import React, { useEffect } from 'react';
// eslint-disable-next-line
import { useDispatch, useSelector } from 'react-redux';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import ReactGA from 'react-ga4';
import WithGA from './hocs/WithGA';

// actions
import getGACode from './utils/tracking';
import { validateTheme } from './actions/theme';
// eslint-disable-next-line
import { updateAgentStatus, endCall, connectLogout } from './actions/telephony';

// components
import FormLoader from './views/load';
import Enrollment from './views/enroll';
import AWSConnectSSO from './views/awsconnect';
import Softphone from './views/softphone';
import SAMLIframe from './views/awsconnect/SAMLIframe';

import './index.scss';

function App() {
  // const dispatch = useDispatch();
  const {
    loginIframeDebug,
    htmlSiteTitle,
    htmlSiteFavicon,
  } = useSelector(store => store.theme);

  useEffect(() => {
    // init google analytics
    getGACode().then(code => {
      ReactGA.initialize(code);
      ReactGA.send('pageview');
    });

    // set theme validation interval
    window.setInterval(validateTheme, 8000);

    // if window is closed while in a call, attempt to
    // end call and logout of connect.
    window.addEventListener('beforeunload', () => {
      // dispatch({ type: 'CLEAR' });
      // updateAgentStatus('Offline');
      endCall();
      connectLogout();
    });
  }, []);

  if (htmlSiteTitle) {
    document.title = htmlSiteTitle;
  }
  if (htmlSiteFavicon) {
    const link = document.getElementById('favicon');
    link.href = htmlSiteFavicon;
  }

  return (
    <BrowserRouter>
      <WithGA>
        <Routes>
          <Route path="/load" element={<FormLoader />} />
          <Route path="/enroll/*" element={<Enrollment />} />
          <Route path="/connect-sso" element={<AWSConnectSSO />} />
          <Route path="/softphone/*" element={<Softphone />} />
          <Route path="/saml" element={<SAMLIframe />} />
        </Routes>
      </WithGA>

      <div
        id="connect-login-iframe-container"
        style={{
          display: loginIframeDebug ? 'block' : 'none',
          height: '600px',
          right: '0px',
          top: '0px',
          position: 'absolute',
          zIndex: '9',
        }}
      />
      <div
        id="connect-iframe-container"
        style={{
          display: loginIframeDebug ? 'block' : 'none',
          height: '600px',
          left: '0px',
          top: '0px',
          position: 'absolute',
          zIndex: '9',
        }}
      />
    </BrowserRouter>
  );
}

export default App;
